import { useContext } from "react";

import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import { StaticBarStateContext } from "../../context/StaticBarContext";
import CurrentBalance from "../fields/CurrentBalance";
import Liability from "../fields/Liability";
import MaxPainLevel from "../fields/MaxPainLevel";
import MedicalLimits from "../fields/MedicalLimits";
import NoAccessMessage from "../fields/NoAccessMessage";
import PreApprovedMedicalAmount from "../fields/PreApprovedMedicalAmount";
import RunningTotal from "../fields/RunningTotal";
import Column from "../ui/Column";
import STRINGS from "../utils/strings";

const CoverageSummary = () => {
  const state = useContext(StaticBarStateContext);

  return (
    <Column>
      {state.data?.liabilityStatus && (
        <PermissionWrapper permission={state.data?.liabilityStatus?.can_view}>
          <Liability
            fieldName={state.data?.liabilityStatus?.fieldName}
            value={state.data?.liabilityStatus?.value}
            flag={state.data?.liabilityStatus?.flag_state}
            clock={state.data?.liabilityStatus?.clock_state}
          />
        </PermissionWrapper>
      )}
      {state.data?.maxPainLevel && (
        <PermissionWrapper
          permission={state.data?.maxPainLevel?.can_view && state.data?.maxPainBodyPart?.can_view}
        >
          <MaxPainLevel
            fieldName={state.data?.maxPainLevel?.fieldName}
            painLevel={state.data?.maxPainLevel?.value}
            bodyPart={state.data?.maxPainBodyPart?.value}
            flag={state.data?.maxPainLevel?.flag_state}
            clock={state.data?.maxPainLevel?.clock_state}
          />
        </PermissionWrapper>
      )}

      <div className="space-between flex">
        {state.data?.medicalLimits && (
          <>
            <PermissionWrapper permission={state.data?.medicalLimits?.can_view}>
              <MedicalLimits
                fieldName={state.data?.medicalLimits?.fieldName}
                value={state.data?.medicalLimits?.value}
                flag={state.data?.medicalLimits?.flag_state}
                clock={state.data?.medicalLimits?.clock_state}
              />
            </PermissionWrapper>
            <PermissionWrapper permission={!state.data?.medicalLimits?.can_view}>
              <NoAccessMessage value={STRINGS.MEDICAL_LIMITS_NO_PERM} />
            </PermissionWrapper>
          </>
        )}
        {state.data?.providerMax && (
          <PermissionWrapper permission={state.data?.providerMax?.can_view}>
            <PreApprovedMedicalAmount
              fieldName={state.data?.providerMax?.fieldName}
              value={state.data?.providerMax?.value}
              flag={state.data?.providerMax?.flag_state}
              clock={state.data?.providerMax?.clock_state}
            />
          </PermissionWrapper>
        )}
      </div>
      <div className="flex justify-between">
        {state.data?.currentBalanceTotal && (
          <>
            <PermissionWrapper permission={state.data?.currentBalanceTotal?.can_view}>
              <CurrentBalance
                fieldName={state.data?.currentBalanceTotal?.fieldName}
                value={state.data?.currentBalanceTotal?.value}
                flag={state.data?.currentBalanceTotal?.flag_state}
                clock={state.data?.currentBalanceTotal?.clock_state}
              />
            </PermissionWrapper>
            <PermissionWrapper permission={!state.data?.currentBalanceTotal?.can_view}>
              <NoAccessMessage value={STRINGS.CURRENT_BALANCE_NO_PERM} />
            </PermissionWrapper>
          </>
        )}
        {state.data?.runningTotal && (
          <>
            <PermissionWrapper permission={state.data?.runningTotal?.can_view}>
              <RunningTotal
                fieldName={state.data?.runningTotal?.fieldName}
                value={state.data?.runningTotal?.value}
                flag={state.data?.runningTotal?.flag_state}
                clock={state.data?.runningTotal?.clock_state}
              />
            </PermissionWrapper>
            <PermissionWrapper permission={!state.data?.runningTotal?.can_view}>
              <NoAccessMessage value={STRINGS.RUNNING_TOTAL_NO_PERM} />
            </PermissionWrapper>
          </>
        )}
      </div>
    </Column>
  );
};

export default CoverageSummary;
